export default "__VITE_ASSET__DTupk_Yv__"